import { fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { SELECT_TRIP_FOR_SRP_MAP } from 'app/constants';
import handleTripHover from './handleTripHover';


export default function* watchTripHover() {
  yield fork(takeLatest, SELECT_TRIP_FOR_SRP_MAP, handleTripHover);
}
